import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import moment from "moment";
import axios from "axios";
import HtmlParser from "react-html-parser";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { HomeUpdatedArrowIcon } from "../../../app-constants";

export default function Insights() {
  const [isLoadedAll, setIsLoadedAll] = useState(false);
  const [isLoadedWorkshop, setIsLoadedWorkshop] = useState(false);
  const [isLoadedEvent, setIsLoadedEvent] = useState(false);
  const [isLoadedPodcast, setIsLoadedPodcast] = useState(false);

  const [userDataAll, setUserDataAll] = useState([]);
  const [userDataWorkshop, setUserDataWorkshop] = useState([]);
  const [userDataEvent, setUserDataEvent] = useState([]);
  const [userDataPodcast, setUserDataPodcast] = useState([]);

  //fetch all Blogs
  const getBlogsAll = async () => {
    setIsLoadedAll(true);
    try {
      const response = await axios.get(
        // "https://www.tekrevol.com/blogs/wp-json/wp/v2/posts?_embed&per_page=6&categories=769&orderby=id&order=desc"
        "https://www.tekrevol.com/blogs/wp-json/wp/v2/posts?include=14748,14888,14803&_embed"
      );
      setUserDataAll(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoadedAll(false);
    }
  };
  const sortedUserDataAll = [...userDataAll].sort(
    (a, b) => new Date(b.modified) - new Date(a.modified)
  );

  //fetch all Events
  const getBlogsEvent = async () => {
    setIsLoadedEvent(true);
    try {
      const response = await axios.get(
        //"https://www.tekrevol.com/blogs/wp-json/wp/v2/posts?_embed&per_page=6&categories=769&orderby=id&order=desc"
        "https://www.tekrevol.com/blogs/wp-json/wp/v2/posts?include=13926,13385,13627&_embed"
      );
      setUserDataEvent(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoadedEvent(false);
    }
  };
  const sortedUserDataEvent = [...userDataEvent].sort(
    (a, b) => new Date(b.modified) - new Date(a.modified)
  );

  //fetch all Workshop
  const getBlogsWorkshop = async () => {
    setIsLoadedWorkshop(true);
    try {
      const response = await axios.get(
        //"https://www.tekrevol.com/blogs/wp-json/wp/v2/posts?_embed&per_page=6&categories=769&orderby=id&order=desc"
        "https://www.tekrevol.com/blogs/wp-json/wp/v2/posts?include=13901,12812,13814&_embed"
      );
      setUserDataWorkshop(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoadedWorkshop(false);
    }
  };
  const sortedUserDataWorkshop = [...userDataWorkshop].sort(
    (a, b) => new Date(b.modified) - new Date(a.modified)
  );

  //fetch all Podcast
  const getBlogsPodcast = async () => {
    setIsLoadedPodcast(true);
    try {
      const response = await axios.get(
        //"https://www.tekrevol.com/blogs/wp-json/wp/v2/posts?_embed&per_page=6&categories=769&orderby=id&order=desc"
        "https://www.tekrevol.com/blogs/wp-json/wp/v2/posts?include=11935,7545,6932&_embed"
      );
      setUserDataPodcast(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoadedPodcast(false);
    }
  };
  const sortedUserDataPodcast = [...userDataPodcast].sort(
    (a, b) => new Date(b.modified) - new Date(a.modified)
  );

  useEffect(() => {
    getBlogsWorkshop();
    getBlogsEvent();
    getBlogsPodcast();
    getBlogsAll();
  }, []);

  return (
    <section className="tekrevol__insights overflow-x-hidden p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div className="example example-bottom" data-text="Publications">
              <h2>Insights</h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="tabs-wrap">
              <Tabs
                defaultActiveKey="blogs"
                id="blog-tab"
                className="blog-tabs "
                justify
              >
                <Tab eventKey="blogs" title="Blogs">
                  <Swiper
                    spaceBetween={25}
                    slidesPerView={3}
                    onSlideChange={() => console.log("slide change")}
                    onSwiper={(swiper) => console.log(swiper)}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                      },
                      575: {
                        slidesPerView: 1.5,
                      },
                      666: {
                        slidesPerView: 1.8,
                      },
                      768: {
                        slidesPerView: 2,
                      },
                      1199: {
                        slidesPerView: 2,
                      },
                      1200: {
                        slidesPerView: 3,
                      },
                    }}
                    className="carosal_blogs"
                  >
                    {sortedUserDataAll.map((value, i) => {
                      const featuredMedia =
                        value._embedded["wp:featuredmedia"][0];
                      const mediumLargeSize =
                        featuredMedia?.media_details?.sizes?.["medium_large"];
                      return (
                        <SwiperSlide>
                          <div className="blog-item tekrevol_gray_bg" key={i}>
                            <Link
                              to={`/blogs/${value.slug}`}
                              aria-label={HtmlParser(value.title.rendered)}
                              className="img-link"
                            >
                              <img
                                src={
                                  mediumLargeSize
                                    ? mediumLargeSize.source_url
                                    : ""
                                }
                                alt={
                                  featuredMedia?.title?.rendered || "Blog Image"
                                }
                                className="img-fluid"
                                layout="constrained"
                                placeholder="blurred"
                                formats={["auto"]}
                                width={mediumLargeSize?.width || 508}
                                height={mediumLargeSize?.height || 286}
                              />
                            </Link>

                            <div className="content">
                              <div className="inner-wrap">
                                <h2 className="title">
                                  {HtmlParser(value.title.rendered)}
                                </h2>
                                {HtmlParser(value.excerpt.rendered)}
                              </div>

                              <div className="bottom-wrap">
                                {/* <span className="date">{moment(value.date).format("MMMM d, YYYY")}{" "}</span> */}
                                <span className="date">
                                  {moment(value.modified).format(
                                    "MMMM D, YYYY"
                                  )}{" "}
                                </span>
                                <Link
                                  to={`/blogs/${value.slug}`}
                                  aria-label={HtmlParser(value.title.rendered)}
                                  className="box-link"
                                >
                                  Learn More {HomeUpdatedArrowIcon}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                  <Col
                    xs={12}
                    md={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    className="mt-md-5 mt-4"
                  >
                    <div className="btn-wrap text-center">
                      <a
                        href="https://www.tekrevol.com/blogs/"
                        className="btn-pri"
                      >
                        Show more
                      </a>
                    </div>
                  </Col>
                </Tab>
                <Tab eventKey="events" title="Events">
                  <Swiper
                    spaceBetween={25}
                    slidesPerView={3}
                    onSlideChange={() => console.log("slide change")}
                    onSwiper={(swiper) => console.log(swiper)}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                      },
                      575: {
                        slidesPerView: 1.5,
                      },
                      666: {
                        slidesPerView: 1.8,
                      },
                      768: {
                        slidesPerView: 2,
                      },
                      1199: {
                        slidesPerView: 2,
                      },
                      1200: {
                        slidesPerView: 3,
                      },
                    }}
                    className="carosal_blogs"
                  >
                    {sortedUserDataEvent.map((value, i) => {
                      const featuredMedia =
                        value._embedded["wp:featuredmedia"][0];
                      const mediumLargeSize =
                        featuredMedia?.media_details?.sizes?.["medium_large"];

                      return (
                        <SwiperSlide key={i}>
                          <div className="blog-item tekrevol_gray_bg">
                            <Link
                              to={`/blogs/${value.slug}`}
                              aria-label={HtmlParser(value.title.rendered)}
                              className="img-link"
                            >
                              <img
                                src={
                                  mediumLargeSize
                                    ? mediumLargeSize.source_url
                                    : ""
                                }
                                alt={
                                  featuredMedia?.title?.rendered || "Blog Image"
                                }
                                className="img-fluid"
                                layout="constrained"
                                placeholder="blurred"
                                formats={["auto"]}
                                width={mediumLargeSize?.width || 508}
                                height={mediumLargeSize?.height || 286}
                              />
                            </Link>

                            <div className="content">
                              <div className="inner-wrap">
                                <h2 className="title">
                                  {HtmlParser(value.title.rendered)}
                                </h2>
                                {HtmlParser(value.excerpt.rendered)}
                              </div>

                              <div className="bottom-wrap">
                                <span className="date">
                                  {moment(value.modified).format(
                                    "MMMM D, YYYY"
                                  )}
                                </span>
                                <Link
                                  to={`/blogs/${value.slug}`}
                                  aria-label={HtmlParser(value.title.rendered)}
                                  className="box-link"
                                >
                                  Learn More {HomeUpdatedArrowIcon}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </Tab>
                <Tab eventKey="workshops" title="Workshops">
                  <Swiper
                    spaceBetween={25}
                    slidesPerView={3}
                    onSlideChange={() => console.log("slide change")}
                    onSwiper={(swiper) => console.log(swiper)}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                      },
                      575: {
                        slidesPerView: 1.5,
                      },
                      666: {
                        slidesPerView: 1.8,
                      },
                      768: {
                        slidesPerView: 2,
                      },
                      1199: {
                        slidesPerView: 2,
                      },
                      1200: {
                        slidesPerView: 3,
                      },
                    }}
                    className="carosal_blogs"
                  >
                    {sortedUserDataWorkshop.map((value, i) => {
                      const featuredMedia =
                        value._embedded["wp:featuredmedia"][0];
                      const mediumLargeSize =
                        featuredMedia?.media_details?.sizes?.["medium_large"];

                      return (
                        <SwiperSlide>
                          <div className="blog-item tekrevol_gray_bg" key={i}>
                            <Link
                              to={`/blogs/${value.slug}`}
                              aria-label={HtmlParser(value.title.rendered)}
                              className="img-link"
                            >
                              <img
                                src={
                                  mediumLargeSize
                                    ? mediumLargeSize.source_url
                                    : ""
                                }
                                alt={
                                  featuredMedia?.title?.rendered || "Blog Image"
                                }
                                className="img-fluid"
                                layout="constrained"
                                placeholder="blurred"
                                formats={["auto"]}
                                width={mediumLargeSize?.width || 508}
                                height={mediumLargeSize?.height || 286}
                              />
                            </Link>

                            <div className="content">
                              <div className="inner-wrap">
                                <h2 className="title">
                                  {HtmlParser(value.title.rendered)}
                                </h2>
                                {HtmlParser(value.excerpt.rendered)}
                              </div>

                              <div className="bottom-wrap">
                                <span className="date">
                                  {moment(value.modified).format(
                                    "MMMM D, YYYY"
                                  )}{" "}
                                </span>
                                {/* <span className="date">{moment(value.date).format("MMMM d, YYYY")}{" "}</span> */}
                                <Link
                                  to={`/blogs/${value.slug}`}
                                  aria-label={HtmlParser(value.title.rendered)}
                                  className="box-link"
                                >
                                  Learn More {HomeUpdatedArrowIcon}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </Tab>

                <Tab eventKey="podcasts" title="Podcasts">
                  <Swiper
                    spaceBetween={25}
                    slidesPerView={3}
                    onSlideChange={() => console.log("slide change")}
                    onSwiper={(swiper) => console.log(swiper)}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                      },
                      575: {
                        slidesPerView: 1.5,
                      },
                      666: {
                        slidesPerView: 1.8,
                      },
                      768: {
                        slidesPerView: 2,
                      },
                      1199: {
                        slidesPerView: 2,
                      },
                      1200: {
                        slidesPerView: 3,
                      },
                    }}
                    className="carosal_blogs"
                  >
                    {sortedUserDataPodcast.map((value, i) => {
                      const featuredMedia =
                        value._embedded["wp:featuredmedia"][0];
                      const mediumLargeSize =
                        featuredMedia?.media_details?.sizes?.["medium_large"];

                      return (
                        <SwiperSlide>
                          <div className="blog-item tekrevol_gray_bg" key={i}>
                            <Link
                              to={`/blogs/${value.slug}`}
                              aria-label={HtmlParser(value.title.rendered)}
                              className="img-link"
                            >
                              <img
                                src={
                                  mediumLargeSize
                                    ? mediumLargeSize.source_url
                                    : ""
                                }
                                alt={
                                  featuredMedia?.title?.rendered || "Blog Image"
                                }
                                className="img-fluid"
                                layout="constrained"
                                placeholder="blurred"
                                formats={["auto"]}
                                width={mediumLargeSize?.width || 508}
                                height={mediumLargeSize?.height || 286}
                              />
                            </Link>

                            <div className="content">
                              <div className="inner-wrap">
                                <h2 className="title">
                                  {HtmlParser(value.title.rendered)}
                                </h2>
                                {HtmlParser(value.excerpt.rendered)}
                              </div>

                              <div className="bottom-wrap">
                                <span className="date">
                                  {moment(value.modified).format(
                                    "MMMM D, YYYY"
                                  )}{" "}
                                </span>
                                {/* <span className="date">{moment(value.date).format("MMMM d, YYYY")}{" "}</span> */}
                                <Link
                                  to={`/blogs/${value.slug}`}
                                  aria-label={HtmlParser(value.title.rendered)}
                                  className="box-link"
                                >
                                  Learn More {HomeUpdatedArrowIcon}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </Tab>
              </Tabs>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
